export default defineNuxtPlugin((nuxtApp) => {
	useHead({
		script: [
			{
				id: 'ld-json-schema',
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://www.schema.org',
					'@type': 'Organization',
					name: 'Veon AdTech Digital',
					url: 'http://veonadtech.com',
					logo: 'http://veonadtech.com/images/logo/veon_adtech_digital_white_center.svg',
					image: 'http://veonadtech.com/images/logo/veon_adtech_digital_white_center.svg',
					description: 'VEON AdTech Digital - Building the world without information pollution',
					address: {
						'@type': 'PostalAddress',
						streetAddress: 'Olimlar 4',
						addressLocality: 'Tashkent',
						addressRegion: 'Tashkent',
						postalCode: '100164',
						addressCountry: 'Uzbekistan',
					},
					geo: {
						'@type': 'GeoCoordinates',
						latitude: '41.341379',
						longitude: '69.335396',
					},
					hasMap: 'https://maps.app.goo.gl/CTfKhDY6waVcBd3W9',
					openingHours: 'Mo 09:00-18:00 Tu 09:00-18:00 We 09:00-18:00 Th 09:00-18:00 Fr 09:00-18:00',
				}),
			},
		],
		__dangerouslyDisableSanitizersByTagID: {
			'ld-json-schema': ['innerHTML'],
		},
	} as any)
})
